class TinkerBlogLoadMore {
  constructor() {
    this.container = document.querySelector('.blog-posts-container');
    this.paginationDiv = document.getElementById('blog-pagination');
    this.loadMoreBtn = document.querySelector('.blog-load-more-btn');
    
    if (this.loadMoreBtn && this.container) {
      this.init();
    }
  }

  init() {
    this.originalBtnText = this.loadMoreBtn.textContent;
    this.loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }

  loadMore() {
    const nextPageUrl = this.loadMoreBtn.getAttribute('data-next-url');
    
    if (!nextPageUrl) {
      console.warn('No next page URL found');
      return;
    }
    
    this.setLoadingState(true);
    
    fetch(nextPageUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('HTTP error! status: ' + response.status);
        }
        return response.text();
      })
      .then(html => {
        this.appendNewPosts(html);
      })
      .catch(error => {
        console.error('Error loading more posts:', error);
        this.handleError();
      });
  }

  appendNewPosts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newPosts = doc.querySelectorAll('.blog-post-item');
    
    if (newPosts.length === 0) {
      this.showAllLoaded();
      return;
    }
    
    newPosts.forEach((post, index) => {
      const postClone = post.cloneNode(true);
      postClone.style.opacity = '0';
      postClone.style.transform = 'translateY(20px)';
      postClone.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      this.container.appendChild(postClone);
      
      setTimeout(() => {
        postClone.style.opacity = '1';
        postClone.style.transform = 'translateY(0)';
      }, index * 80);
    });
    
    this.updatePagination(doc);
  }

  updatePagination(doc) {
    const newLoadMoreBtn = doc.querySelector('.blog-load-more-btn');
    const newPaginationInfo = doc.querySelector('.blog-pagination-info');
    
    if (newLoadMoreBtn) {
      const nextUrl = newLoadMoreBtn.getAttribute('data-next-url');
      this.loadMoreBtn.setAttribute('data-next-url', nextUrl);
      this.setLoadingState(false);
    } else {
      this.showAllLoaded();
    }
    
    if (newPaginationInfo && this.paginationDiv) {
      const currentInfo = this.paginationDiv.querySelector('.blog-pagination-info');
      if (currentInfo) {
        currentInfo.textContent = newPaginationInfo.textContent;
      }
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.loadMoreBtn.disabled = true;
      this.loadMoreBtn.classList.add('loading');
      this.loadMoreBtn.textContent = 'Loading...';
      this.loadMoreBtn.setAttribute('aria-busy', 'true');
    } else {
      this.loadMoreBtn.disabled = false;
      this.loadMoreBtn.classList.remove('loading');
      this.loadMoreBtn.textContent = this.originalBtnText;
      this.loadMoreBtn.setAttribute('aria-busy', 'false');
    }
  }

  showAllLoaded() {
    if (this.paginationDiv) {
      this.paginationDiv.innerHTML = '<p class="all-posts-loaded">All posts loaded</p>';
    }
  }

  handleError() {
    this.setLoadingState(false);
    const errorMsg = document.createElement('div');
    errorMsg.className = 'load-more-error';
    errorMsg.textContent = 'Unable to load more posts. Please try again.';
    errorMsg.setAttribute('role', 'alert');
    this.paginationDiv.insertBefore(errorMsg, this.loadMoreBtn);
    
    setTimeout(() => {
      errorMsg.remove();
    }, 5000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TinkerBlogLoadMore();
  });
} else {
  new TinkerBlogLoadMore();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new TinkerBlogLoadMore();
  });
}